import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    width: "17",
    height: "16",
    style: style,
    viewBox: "0 0 17 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8334 8.00033C15.8334 12.0504 12.5502 15.3337 8.50008 15.3337C4.44999 15.3337 1.16675 12.0504 1.16675 8.00033C1.16675 3.95024 4.44999 0.666992 8.50008 0.666992C12.5502 0.666992 15.8334 3.95024 15.8334 8.00033ZM12.187 5.02054L9.20722 8.00033L12.187 10.9801L11.4799 11.6872L8.50011 8.70744L5.52034 11.6872L4.81323 10.9801L7.793 8.00033L4.81323 5.02055L5.52034 4.31344L8.50011 7.29322L11.4799 4.31344L12.187 5.02054Z",
    fill: "black",
    fillOpacity: "0.26"
  }));
};
export default SVGComponent;